<template>
    <div class="dialog-full-size">
        <div class="dialog-full-size-wrapper">
            <div class="header">
                <CompassIconButton icon="close" size="large" @click="$emit('handleClose')" />
                <h1>{{ title }}</h1>
            </div>
            <slot name="content" />
        </div>
        <slot name="footer" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    created() {
        const bodyElement = document.querySelector('body');
        bodyElement.style.overflow = 'hidden';
        bodyElement.style.height = '100%';
    },
    destroyed() {
        const bodyElement = document.querySelector('body');
        bodyElement.style.overflow = '';
        bodyElement.style.height = '';
    },
};
</script>

<style scoped lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.dialog-full-size {
    background-color: $white;
    border-radius: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1000;
    .dialog-full-size-wrapper {
        flex: 1;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }
    .header {
        display: flex;
        flex-direction: column;
        h1 {
            margin: 0 auto 24px;
            max-width: 1440px;
            width: 100%;
            @media (max-width: 1440px) {
                max-width: 1040px;
            }
        }
        .compass-icon-button {
            align-self: flex-end;
            margin: var(--spacing-4) var(--spacing-4) var(--spacing-5) 0;
        }
    }
    .content {
        display: flex;
        height: 100%;
        & > div {
            margin: 0 auto;
            max-width: 1440px;
            width: 100%;
            @media (max-width: 1440px) {
                max-width: 1040px;
            }
        }
    }

    .footer {
        background-color: $white;
        bottom: 0;
        box-shadow: 0 0 8px rgba(17, 17, 17, 0.2);
        display: flex;
        justify-content: flex-end;
        flex-shrink: 0;
        z-index: 1001;
        .compass-button {
            height: 56px;
            margin: 32px 40px;
            width: 448px;
        }
    }
}
</style>
